import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RedocStandalone } from 'redoc';
import { celticBlue, appleGreen, orangeYellow, madderLake, oxfordBlue, primaryFont, darkMoss, hexToRgba, peppermint, tutu, monospaceFont, smallBreakpoint, mediumBreakpoint, largeBreakpoint, FAB, white, cultured, heroOrange, } from '@phishtool/ui';
import { useEffect, useState } from 'react';
import { StyledSubNavHeading } from './styled';
import { useExpandableTags } from './use-expandable-tags';
const useFAB = () => {
    const menuSelector = '.menu-content';
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const menu = document.querySelector(menuSelector);
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle('is-open', isOpen);
    }, [isOpen]);
    return [isOpen, setIsOpen];
};
const Home = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isOpen, setIsOpen] = useFAB();
    const specUrl = `/spec.json`;
    useExpandableTags(isLoaded);
    useEffect(() => {
        document.body.classList.add('redoc');
        return () => {
            document.body.classList.remove('redoc');
        };
    }, []);
    return (_jsxs("div", { className: "redoc-content", children: [_jsx(StyledSubNavHeading, { isSubNavOpen: isOpen, children: "API Documentation" }), _jsx(RedocStandalone, { specUrl: specUrl, onLoaded: () => setIsLoaded(true), options: {
                    hideFab: true,
                    showWebhookVerb: true,
                    showObjectSchemaExamples: true,
                    disableSearch: true,
                    hideDownloadButton: true,
                    sortPropsAlphabetically: true,
                    scrollYOffset: 54,
                    theme: {
                        breakpoints: {
                            small: `${smallBreakpoint - 1}px`,
                            medium: `${mediumBreakpoint - 1}px`,
                            large: `${largeBreakpoint - 1}px`,
                        },
                        spacing: {
                            unit: 6,
                            sectionHorizontal: ({ spacing }) => spacing.unit * 6,
                            sectionVertical: ({ spacing }) => spacing.unit * 3,
                        },
                        colors: {
                            text: {
                                primary: oxfordBlue,
                                secondary: oxfordBlue,
                            },
                            primary: {
                                main: celticBlue,
                            },
                            success: {
                                main: appleGreen,
                            },
                            warning: {
                                main: orangeYellow,
                            },
                            error: {
                                main: madderLake,
                            },
                            responses: {
                                success: {
                                    color: darkMoss,
                                    backgroundColor: hexToRgba(peppermint, 0.4),
                                    tabTextColor: ({ colors }) => colors.responses.success.color,
                                },
                                error: {
                                    color: madderLake,
                                    backgroundColor: hexToRgba(tutu, 0.4),
                                    tabTextColor: ({ colors }) => colors.responses.error.color,
                                },
                            },
                        },
                        typography: {
                            fontFamily: primaryFont,
                            headings: {
                                fontFamily: primaryFont,
                            },
                            code: {
                                fontSize: '13px',
                                fontFamily: monospaceFont,
                                backgroundColor: 'transparent',
                                color: heroOrange,
                            },
                        },
                        sidebar: {
                            width: '252px',
                            backgroundColor: white,
                            textColor: oxfordBlue,
                            groupItems: {
                                activeBackgroundColor: cultured,
                            },
                            level1Items: {
                                activeBackgroundColor: cultured,
                            },
                            arrow: {
                                size: '0px',
                            },
                        },
                        rightPanel: {
                            backgroundColor: white,
                        },
                        codeBlock: {
                            backgroundColor: oxfordBlue,
                        },
                    },
                } }), _jsx(FAB, { isOpen: isOpen, setIsOpen: setIsOpen })] }));
};
export default Home;
